import * as React from 'react';

import {Body} from './body';
import {Title} from './title';

import styles from './title-with-body.module.css';

type Props = {
    title: string;
    body: string;
};

export function TitleWithBody(props: Props) {
    return (
        <div className={styles.container}>
            <Title>{props.title}</Title>
            <Body>{props.body}</Body>
        </div>
    );
}
